/**
 * Creates an image grid for profile view
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MediaGrid from '../../../components/media/MediaGrid';
import OverlayImage from '../../../components/media/OverlayImage';
import SingleMediaBlock from '../../../components/media/SingleMediaBlock';
import Gallery from '../../../components/gallery/GalleryContainer';

import analytics, * as trackingTypes from '../../../actions/analyticsActions';

class ImageCollection extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        images: PropTypes.array,
    };

    state = { showGallery: false };

    onImageClick(index, e) {
        e.preventDefault();

        this.setState({
            showGallery: true,
            imageClickedIndex: index,
        });

        this.props.dispatch(analytics(trackingTypes.VIEW_IMAGE));
    }

    onExitClick = () => {
        this.setState({ showGallery: false });
    };

    handleShowMore = () => {
        this.props.dispatch(analytics(trackingTypes.SHOW_MORE_IMAGES));
    };

    renderGallery() {
        if (this.state.showGallery) {
            return (
                <Gallery
                    imageIndex={this.state.imageClickedIndex}
                    images={this.props.images}
                    onExitClick={this.onExitClick}
                />
            );
        }
    }

    renderImages() {
        const images = this.props.images;

        if (!images || !images.length) {
            return <span />;
        }

        const children =
            images.length === 1 ? (
                <SingleMediaBlock
                    description={images[0].description}
                    imgSrc={images[0].image.urls.preview}
                    onImageClick={this.onImageClick.bind(this, 0)}
                />
            ) : (
                images.map((img, i) => (
                    <div key={`image-${i}`}>
                        <OverlayImage
                            defaultValue={img.description}
                            imgSrc={img.image.urls.preview}
                            onImageClick={this.onImageClick.bind(this, i)}
                        />
                    </div>
                ))
            );

        return (
            <div>
                {this.renderGallery()}
                <MediaGrid onShowMore={this.handleShowMore}>
                    {children}
                </MediaGrid>
            </div>
        );
    }

    render() {
        const { images } = this.props;

        if (!images || images.length === 0) return null;

        return <section>{this.renderImages()}</section>;
    }
}

export default connect(() => ({}))(ImageCollection);
